export default __webpack_public_path__ + "static/media/spinner.7dbbd1f0.svg";